<template>
  <div class="vc-chart-wrap">
    <div class="history-tabs">
      <button v-for="(tab, i) in tabs" :key="i" class="history-tab" :class="getTabClass(i)"
        @click="gethistory(tab.tnum, tab.tunit, i)">{{ tab.label }}</button>
    </div>
    <div class="chart-card">
      <div ref="chartRef" class="history-chart"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoltCurrChartKS1",
  props: ["did"],
  data() {
    return {
      tabs: [
        { label: "1小时", tnum: 1, tunit: "hour" },
        { label: "6小时", tnum: 6, tunit: "hour" },
        { label: "1天", tnum: 1, tunit: "day" },
        { label: "1周", tnum: 7, tunit: "day" },
      ],
      activeIndex: 0,
      voltList: [],
      currList: [],
      timeList: [],
    };
  },
  mounted() {
    this.gethistory(1, "hour", 0);
  },
  methods: {
    getTabClass(i) {
      return i === this.activeIndex ? "history-tab--active" : "";
    },
    gethistory(tnum, tunit, idx) {
      var self = this;
      self.activeIndex = idx;
      self.voltList = [];
      self.currList = [];
      self.timeList = [];
      const qs = require("qs");
      self.$axios
        .post("/api/dev/ks1/history", qs.stringify({ did: self.did, tnum: tnum, tunit: tunit }))
        .then(function (response) {
          // response.data = { error_code, data: { v: [...], t: [...] } }
          var raw = response.data;
          console.log("KS1 history raw keys:", Object.keys(raw));
          if (raw.error_code === 0) {
            var inner = JSON.parse(JSON.stringify(raw.data || {}));
            console.log("inner data keys:", Object.keys(inner));
            // inner = { error_code: 0, data: { v: [...], t: [...] } }
            var payload = inner.data || {};
            var vArr = payload.v || [];
            var tArr = payload.t || [];
            console.log("vArr len:", vArr.length, "tArr len:", tArr.length);
            for (var i = 0; i < tArr.length && i < vArr.length; i++) {
              var item = vArr[i];
              if (item && item.length >= 2) {
                self.voltList.push(Number(item[0]));
                self.currList.push(Number(item[1]));
                self.timeList.push(tArr[i]);
              }
            }
            console.log("voltList:", self.voltList.length, "currList:", self.currList.length, "timeList:", self.timeList.length);
            self.$nextTick(function () {
              self.drawChart();
            });
          } else if (raw.error_code === 301) {
            self.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(function (err) {
          console.log("KS1 history error:", err);
        });
    },
    drawChart() {
      var self = this;
      var chartDom = self.$refs.chartRef;
      if (!chartDom) {
        console.log("chartDom is null");
        return;
      }
      console.log("chartDom offsetHeight:", chartDom.offsetHeight);
      if (chartDom.offsetHeight === 0) {
        setTimeout(function () { self.drawChart(); }, 200);
        return;
      }
      if (self.timeList.length === 0) {
        console.log("no data, skip draw");
        return;
      }
      var myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,0.95)",
          borderColor: "#e2e8f0",
          borderWidth: 1,
          textStyle: { color: "#475569", fontSize: 12 },
          formatter: function (params) {
            var html = '<div style="font-weight:600;color:#1e293b;font-size:13px;margin-bottom:4px">' + params[0].axisValue + '</div>';
            for (var j = 0; j < params.length; j++) {
              var p = params[j];
              html += '<div style="display:flex;align-items:center;gap:6px;padding:2px 0">' +
                '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:' + p.color + '"></span>' +
                '<span style="color:#64748b">' + p.seriesName + '：</span>' +
                '<span style="color:#1e293b;font-weight:600">' + p.value + (p.seriesName === '电压' ? 'V' : 'A') + '</span></div>';
            }
            return html;
          }
        },
        legend: {
          data: ["电压", "电流"],
          top: 0,
          right: 0,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { color: "#64748b", fontSize: 12 }
        },
        grid: { left: "10%", right: "8%", top: "18%", bottom: "18%" },
        xAxis: {
          type: "category", data: self.timeList,
          axisLine: { lineStyle: { color: "#e2e8f0" } },
          axisTick: { show: false },
          axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
          splitLine: { show: false },
        },
        yAxis: {
          type: "value",
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
          splitLine: { lineStyle: { color: "#f1f5f9", type: "dashed" } },
        },
        series: [
          {
            name: "电压",
            data: self.voltList,
            type: "line",
            symbol: "none",
            smooth: true,
            lineStyle: { color: "#2dd4bf", width: 2 },
            areaStyle: { color: "rgba(45,212,191,0.08)" },
            itemStyle: { color: "#2dd4bf" },
          },
          {
            name: "电流",
            data: self.currList,
            type: "line",
            symbol: "none",
            smooth: true,
            lineStyle: { color: "#f59e0b", width: 2 },
            areaStyle: { color: "rgba(245,158,11,0.08)" },
            itemStyle: { color: "#f59e0b" },
          },
        ],
      };
      myChart.setOption(option, true);
      console.log("chart drawn");
    },
  },
};
</script>

<style scoped>
.vc-chart-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-tabs {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 0 4px;
}

.history-tab {
  flex: 1;
  height: 32px;
  padding: 0 4px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  white-space: nowrap;
  text-align: center;
}

.history-tab--active {
  background: #2dd4bf;
  color: #fff;
}

.history-tab:not(.history-tab--active) {
  background: #f1f5f9;
  color: #94a3b8;
}

.history-tab:not(.history-tab--active):active {
  background: #e2e8f0;
}

.chart-card {
  background: #ffffff;
  border-radius: 18px;
  padding: 12px 8px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}

.history-chart {
  height: 280px;
  width: 100%;
}
</style>
